var $name="isMobileBreakpoint",$path="app/utilities/isMobileBreakpoint.js",$this={$name,$path,};import { breakpoints } from 'configs';

const isMobileBreakpoint = () => window.innerWidth < breakpoints.xl.min;

export default isMobileBreakpoint;
